import { RequestKind, boolean, string } from '@sb/library/base';
import { BulkPasswordResetInputItem, ChangePasswordInputItem, ChangePasswordResult, DisableAccessInputItem, ImpersonatingAuthenticationInputItem, MfaInputItem, MfaSetupDisplayItem, MfaSetupResult, PasswordResetInputItem, PreauthenticationResultItem, SendEmailResultItem, SendLoginEmailInputItem, UserAuthenticationInputItem, UserPreauthenticationInputItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace AuthenticationRoutes {
    export const Authenticate = ApiRoute.Define({
        URL: `auth`,
        Kind: RequestKind.Post,
        BodyType: UserAuthenticationInputItem,
        ResultType: string
    });

    export const Preauthenticate = ApiRoute.Define({
        URL: `preauth`,
        Kind: RequestKind.Post,
        BodyType: UserPreauthenticationInputItem,
        ResultType: Array<PreauthenticationResultItem>,
        Cancellable: false
    });

    export const Logout = ApiRoute.Define({
        URL: `auth`,
        Kind: RequestKind.Delete,
        ResultType: boolean
    });

    export const RefreshAuthentication = ApiRoute.Define({
        URL: `auth`,
        Kind: RequestKind.Put,
        ResultType: string,
        Cancellable: false
    });

    export const DeleteForProfile = ApiRoute.Define({
        URL: (profileID: string) => `profile/${profileID}/auth`,
        Kind: RequestKind.Delete,
        ResultType: boolean
    });

    export const DisableAccessForProfile = ApiRoute.Define({
        URL: (profileID: string) => `profile/${profileID}/access`,
        Kind: RequestKind.Delete,
        ResultType: boolean
    });

    export const GetImpersonating = ApiRoute.Define({
        URL: (profileID: string) => `profile/${profileID}/auth`,
        Kind: RequestKind.Post,
        ResultType: string,
        BodyType: ImpersonatingAuthenticationInputItem
    });

    export namespace LoginEmail {
        export const Send = ApiRoute.Define({
            URL: `passwords`,
            Kind: RequestKind.Put,
            ResultType: boolean,
            BodyType: PasswordResetInputItem
        });

        export const SendAll = ApiRoute.Define({
            URL: `passwords`,
            Kind: RequestKind.Patch,
            BodyType: BulkPasswordResetInputItem,
            ResultType: boolean
        });
    }

    export const EnableAccess = ApiRoute.Define({
        URL: `access`,
        Kind: RequestKind.Post,
        BodyType: SendLoginEmailInputItem,
        ResultType: SendEmailResultItem
    });

    export const DisableAccess = ApiRoute.Define({
        URL: `access`,
        Kind: RequestKind.Patch,
        BodyType: DisableAccessInputItem,
        ResultType: boolean
    });

    export const ChangePassword = ApiRoute.Define({
        URL: (profileID: string) => `profile/${profileID}/password`,
        Kind: RequestKind.Put,
        BodyType: ChangePasswordInputItem,
        ResultType: ChangePasswordResult
    });

    export namespace Mfa {
        export const Initialize = ApiRoute.Define({
            URL: (profileID: string) => `profile/${profileID}/mfa`,
            Kind: RequestKind.Get,
            ResultType: MfaSetupDisplayItem
        });

        export const Enable = ApiRoute.Define({
            URL: (profileID: string) => `profile/${profileID}/mfa`,
            Kind: RequestKind.Post,
            BodyType: MfaInputItem,
            ResultType: MfaSetupResult
        });

        export const Disable = ApiRoute.Define({
            URL: (profileID: string) => `profile/${profileID}/mfa`,
            Kind: RequestKind.Delete,
            ResultType: boolean
        });
    }
}
